import React from 'react';
import DisModal from './design-system/DisModal';
import DisButton from './design-system/DisButton';

const StreakMilestoneModal = ({ milestone, onClose }) => {
  if (!milestone) return null;

  const emojiMap = {
    fire: '\uD83D\uDD25',
    star: '\u2B50',
    confetti: '\uD83C\uDF89',
  };

  return (
    <DisModal isOpen={true} onClose={onClose} title="">
      <div className="text-center space-y-4 py-4" data-testid="streak-milestone-modal">
        {milestone.emoji === 'confetti' && (
          <div className="absolute inset-0 pointer-events-none overflow-hidden">
            {[...Array(20)].map((_, i) => (
              <div
                key={i}
                className="absolute w-2 h-2 rounded-full"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: '-10px',
                  backgroundColor: ['#FFD700', '#FF6B6B', '#4ECDC4', '#A78BFA', '#F59E0B'][i % 5],
                  animation: `confettiFall ${1.5 + Math.random()}s ease-out forwards`,
                  animationDelay: `${Math.random() * 0.5}s`,
                }}
              />
            ))}
          </div>
        )}

        <div className="text-6xl">
          {emojiMap[milestone.emoji] || '\uD83D\uDD25'}
        </div>
        <h2 className="text-xl font-bold text-gray-800" style={{ fontFamily: "'Caveat', cursive" }}>
          {milestone.message}
        </h2>
        {milestone.days >= 3 && (
          <p className="text-sm text-amber-600">
            +{milestone.days === 3 ? 5 : milestone.days === 7 ? 15 : 0} étoiles bonus !
          </p>
        )}
        <DisButton
          onClick={onClose}
          className="bg-gradient-to-r from-orange-400 to-amber-500 text-white font-medium"
          data-testid="milestone-close-btn"
        >
          Continuons !
        </DisButton>
      </div>

      <style>{`
        @keyframes confettiFall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(400px) rotate(720deg); opacity: 0; }
        }
      `}</style>
    </DisModal>
  );
};

export default StreakMilestoneModal;
